import { cardNode } from "./cardNode";
import { GQL_CONTENTITEM_FRAGMENT_FOR_MEDIA } from "wpp-utilities";
/**
 * Queries and fragments for mediaItems and mediaCategories in graphql-proxy
 */

export const videoDetailPageFromContentItem = (useMediaId) => {
    let outerQueryArgs = "$sourceId: String";
    let innerQueryArgs = "sourceId: $sourceId";

    if (useMediaId) {
        outerQueryArgs = "$mediaId: BigInt";
        innerQueryArgs = "mediaId: $mediaId";
    }

    return `query videoDetailPage(${outerQueryArgs}) {
        contentItem(${innerQueryArgs}) {
            ${GQL_CONTENTITEM_FRAGMENT_FOR_MEDIA}
            updatedAt
            description
            categories {
                name
                slug
            }
            section {
                attributionLevels
                tracking{
                    contentArea
                    subSection1
                    subSection2
                    subSection3
                    subSection4
                }
            }
        }
    }`;
};

export const videoContentItemsByCategorySlugs = () => {
    return `query videoContentItemsByCategorySlugs($lineupOnly: Boolean, $itemsQueryFilters: ItemsQueryFilters, $mediaAspectRatios: [ContentItemAspectRatio!]) {
        allContentItems(lineupOnly: $lineupOnly, itemsQueryFilters: $itemsQueryFilters, targets: [WEB,ALL], mediaAspectRatios: $mediaAspectRatios) {
            nodes {
                ...cardNode
            }
        }
    } ${cardNode}`;
};

export const videoContentItemsBySourceIds = () => {
    return `query videoContentItemsByMediaIds($sourceIds: String, $pageSize: Int) {
        allContentItems(sourceIds: $sourceIds, pageSize: $pageSize, targets: [WEB,ALL], type: "video") {
            nodes {
                ...cardNode
            }
        }
    } ${cardNode}`;
};
